import { LoadStatus } from '@servicetitan/cp-ui';
import { InputFieldState } from '@servicetitan/form-state';
import { inject, injectable } from '@servicetitan/react-ioc';
import { AuthApi, InviteRequest } from 'api';
import { FormState } from 'formstate';
import { computed, makeObservable, observable, runInAction } from 'mobx';
import { emailFieldValidator, requiredEmailFieldValidator } from '../utils/email.validator';

@injectable()
export class AuthRegisterStore {
    @observable status = LoadStatus.None;

    @computed get canSubmit() {
        return !!this.form.$.email.value && !this.form.hasError;
    }

    form = new FormState({
        email: new InputFieldState('')
            .validators(requiredEmailFieldValidator, emailFieldValidator)
            .disableAutoValidation(),
    });

    constructor(@inject(AuthApi) private authApi: AuthApi) {
        makeObservable(this);
    }

    submit = async () => {
        const isValid = await this.form.validate();

        if (!isValid) {
            return;
        }

        runInAction(() => (this.status = LoadStatus.Loading));

        try {
            await this.authApi.client.selfInvite(
                new InviteRequest({
                    contactValue: this.form.$.email.value,
                })
            );

            runInAction(() => (this.status = LoadStatus.Ok));
        } catch {
            runInAction(() => (this.status = LoadStatus.Error));
        }
    };
}
